/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';
/* Thunks */
export const postMergeUserAccountsThunk = createFOAsyncThunk('mergeUserAccount', async (args, { rejectWithValue }) => {
  try {
    return await userApi.mergeUserAccounts(args.currentUserId, args.userToMergeId);
  } catch (error) {
    if (error.response && error.response.status === 400) {
      const { data } = error.response;
      return rejectWithValue({ showAlert: false, data });
    }
    throw error;
  }
});

export const getValidateEmailOrUsernameThunk = createFOAsyncThunk(
  'validateEmail',
  async (args, { rejectWithValue }) => {
    try {
      return await userApi.validateEmail(args, args.extraParams);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return rejectWithValue({ showAlert: false });
      }
      throw error;
    }
  },
);
